export class PCalendarDateMeta {
  day: number;
  month: number;
  year: number;
  otherMonth: boolean;
  selectable: boolean;
  today: boolean;
}
